import httpRequest from '@/utils/request';
import axios from 'axios';

const CancelToken = axios.CancelToken;
const baseUrl = '/Issue';
const createUrlById = (issueId: string) => {
  return `${baseUrl}/${issueId}`;
};
const createStatusUrlById = (issueId: string) => {
  return `${baseUrl}/${issueId}/status`;
};
export let cancel: any;

export const getIssues = (params: IIssue.IRequest.IGetIssues): Promise<IIssue.IResponse.IData> => {
  return httpRequest.get(baseUrl, {
    params,
  });
};
export const getIssueDetail = (issueId: string): Promise<IIssue.IResponse.IData> => {
  return httpRequest.get(baseUrl, {
    params: {
      id: issueId,
      returnComment: true,
    },
    cancelToken: new CancelToken((c) => {
      cancel = c;
    }),
  });
};
export const deleteIssue = (issueId: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.delete(createUrlById(issueId));
};
export const updateIssue = (params: IIssue.IRequest.IUpdateIssue): Promise<IResponseData.IBaseData> => {
  return httpRequest.post(createUrlById(params.id), params.issue);
};
export const updateApproveStatus = (issueId: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.put(createStatusUrlById(issueId), null, {
    params: {
      status: 'Approved',
    },
  });
};
export const updateRejectStatus = (issueId: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.put(createStatusUrlById(issueId), null, {
    params: {
      status: 'Rejected',
    },
  });
};
export const updateCancelStatus = (issueId: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.put(createStatusUrlById(issueId), null, {
    params: {
      status: 'Cancel',
    },
  });
};
export const updateCloseStatus = (issueId: string): Promise<IResponseData.IBaseData> => {
  return httpRequest.put(createStatusUrlById(issueId), null, {
    params: {
      status: 'Closed',
    },
  });
};
